import { ref, onMounted, onUnmounted } from 'vue'

// Реактивное состояние online/offline для отслеживания сетевого подключения
const isOnline = ref(navigator.onLine)
const wasOffline = ref(false) // Флаг для показа сообщения "Соединение восстановлено"
// Відстеження таймауту для очищення при unmount
let wasOfflineTimeoutId = null

// Обработчики событий сети
const handleOnline = () => {
  // Если были offline, показываем уведомление о восстановлении
  if (!isOnline.value) {
    wasOffline.value = true
    // Скасовуємо попередній таймаут, якщо він є
    if (wasOfflineTimeoutId) clearTimeout(wasOfflineTimeoutId)
    // Через 3 секунды скрываем уведомление о восстановлении
    wasOfflineTimeoutId = setTimeout(() => {
      wasOfflineTimeoutId = null
      wasOffline.value = false
    }, 3000)
  }
  isOnline.value = true
}

const handleOffline = () => {
  isOnline.value = false
}

// Composable для использования в компонентах
export function useOnlineStatus() {
  onMounted(() => {
    window.addEventListener('online', handleOnline)
    window.addEventListener('offline', handleOffline)
    // Обновляем состояние при монтировании
    isOnline.value = navigator.onLine
  })

  onUnmounted(() => {
    window.removeEventListener('online', handleOnline)
    window.removeEventListener('offline', handleOffline)
    // Скасовуємо таймаут при unmount
    if (wasOfflineTimeoutId) {
      clearTimeout(wasOfflineTimeoutId)
      wasOfflineTimeoutId = null
    }
  })

  return {
    isOnline,
    wasOffline
  }
}

// Функция для проверки состояния сети без подписки на события (для apiClient)
export function checkOnlineStatus() {
  return navigator.onLine
}

// Класс ошибки для offline состояния
export class OfflineError extends Error {
  constructor(message = 'No internet connection') {
    super(message)
    this.name = 'OfflineError'
    this.isOffline = true
  }
}
